export default __webpack_public_path__ + "static/buy_packs_img-c2800a122110ac70b559cefdd8d60749.png";